export default __webpack_public_path__ + "static/media/918.fa1e478e.png";